
<!-- 外层容器，用于包裹按钮和表格框 -->
<div class="schedule-container">
  <!-- 导出按钮 - 放在框外右上角 -->
  <button class="exportButton" @click="handleDateClick()" :style="{ backgroundColor: exportButtonsColor }">
    <!-- {{ exportButtonText || '导出' }} -->
    导出

  </button>

  <!-- 表格框容器 -->
  <div class="schedule-table-wrapper">
    <div class="schedule-table" tabindex="0">
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th class="date-header header fixed name-header" :style="{ backgroundColor: headerBcakgroungColor }" rowspan="2">姓名</th>
              <th v-for="month in yearMonths" :key="month.month" :colspan="month.weeks.length" class="month-header"
                :style="{ backgroundColor: headerBcakgroungColor }">
                {{ month.month }}月
              </th>
            </tr>
            <tr>
              <th v-for="week in allWeeks" :key="week.key" class="week-header"
                :style="{ backgroundColor: headerBcakgroungColor }">
                第{{ week.weekIndex + 1 }}周<br />
                {{ week.display }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(person, rowIndex) in getCurrentPagePersons" :key="person.employNo">
              <td class="fixed name-cell" rowspan="1">
                <div style="border-top: 1px solid #ccc;border-right: 1px solid #ccc;height: 100%;display: flex;align-items: center;justify-content: center;">
                  {{ person.employName }}
                </div>
              </td>
              <td v-for="(week, colIndex) in allWeeks" :key="colIndex"
                  :class="getCellClass(rowIndex, colIndex)"
                  @dblclick="activateEditor(rowIndex, colIndex)">

                <template v-if="editingCell && editingCell[0] === rowIndex && editingCell[1] === colIndex">
                  <input @blur="handleBlur" placeholder="请输入" ref="myInput" type="text"
                    style="text-align: center; width: 80%;" v-model="localValue[person.employNo][week.key]">
                </template>
                <template v-else>
                  <span :style="getCellStyle(localValue[person.employNo]?.[week.key] || '0')">
                    {{ localValue[person.employNo]?.[week.key] || '0' }}
                  </span>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="uniquePersons.length > 0" class="pagination">
        <button @click="prevPage" :disabled="currentPage === 1">上一页</button>
        <span>第 {{ currentPage }} 页 / 共 {{ totalPages }} 页</span>
        <button @click="nextPage" :disabled="currentPage === totalPages">下一页</button>
      </div>
    </div>
  </div>
</div>
